import { useMemo } from "react";
import {
    useGetProductAccessoriesQuery,
    useGetProductAssociationsQuery,
} from "../../api/product";
import { partitionAssociationGroups } from "../../utils/productDetail/partitionAssociationGroups";

export const useProductAssociatedProducts = (
    productId: number | string | undefined,
    countryId: number | undefined,
    skip = false,
): ReturnType<typeof partitionAssociationGroups> & {
    isAssociationsLoading: boolean;
} => {
    const shouldSkip = skip || !productId || !countryId;

    const { data: accessories = [], isLoading: isAccessoriesLoading } =
        useGetProductAccessoriesQuery(
            { productId: productId ?? "", countryId: countryId ?? 0 },
            { skip: shouldSkip },
        );

    const { data: groups, isLoading: isAssociationGroupsLoading } =
        useGetProductAssociationsQuery(
            { productId: productId ?? "", countryId: countryId ?? 0 },
            { skip: shouldSkip },
        );

    const partitioned = useMemo(
        () => partitionAssociationGroups(accessories, groups),
        [accessories, groups],
    );

    return {
        ...partitioned,
        isAssociationsLoading:
            !shouldSkip && (isAccessoriesLoading || isAssociationGroupsLoading),
    };
};
